export enum dbOperacao{
    Nenhum = 0,
    Incluir = 1,
    Alterar = 2,
    Excluir = 3,
    Consulta = 4
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/enums/dboperacao.ts
 **/